@if(isLoading) {
<app-loading
  class="h-100 w-100 loading-container"
  [text]="'Loading'"
></app-loading>
} @else {
<div class="container-fluid d-flex flex-column">
    <ng-container *ngFor="let item of apiServiceDetails">
        <div class="button-list"  *ngIf="item.addBtnText !== ''">
            <button
              class="release-btn btn-accello-secondary"
              (click)="addNewService('rest')"
            >
              <img
                [src]="'images/virtusa-icons/add-icon-dark.svg' | assetUrl"
                alt="Add Icon"
                width="18"
                height="18"
              />
              {{ item.addBtnText }}
            </button>
        
            <button
              class="release-btn btn-accello-light"
              (click)="removeComponents()"
              [disabled]="!selectedServices.length"
              (focus)="changeRemoveIcon(false)"
              (mouseenter)="changeRemoveIcon(false)"
              (mouseleave)="changeRemoveIcon(false)"
              (blur)="changeRemoveIcon(false)"
              (mousedown)="changeRemoveIcon(true)"
              (mouseup)="changeRemoveIcon(false)"
            >
              <img [src]="iconSrcDelete | assetUrl" width="18" height="18" />
              <span> {{ item.removeBtnText }} </span>
              @if(isLoading){
              <span
                class="spinner-border spinner-border-sm mx-2"
                role="status"
                aria-hidden="true"
              ></span>
              }
            </button>
            <button class="btn-accello-ternary" (click)="refreshData()">
              <img src="assets/images/virtusa-icons/sync.svg" alt="refresh" />
              <span>Refresh</span>
            </button>
          </div>
          @if(item?.dataList?.length) {
        
          <div class="d-flex flex-column mb-4">
            <div class="header-wrapper">
              <span class="accello-general-text14">Rest API Services</span>
            </div>
            <div class="custom-card">
              <app-script-card-tile
                class="w-100"
                [cardList]="item?.dataList"
                (selectedCardsChange)="handleSelectedCards($event)"
                (onEditClick)="onEditFolder($event)"
              ></app-script-card-tile>
            </div>
          </div>
          }
    </ng-container>
</div>
}
